<template>
  <div class="view">
    <aside :opened="menuOpened">
      <!-- <div class="search">
        <div class="input-container">
          <i class="ic ic-search"></i>
          <input placeholder="Search" v-model="searchTerms" type="search">
        </div>
        <button class="ic ic-filter" title="Filter" @click.stop="filtersOpened = 'sort'"></button>
        <div class="filters" v-if="filtersOpened === 'sort'" @click.stop>
          <a @click="filterCompanies('newest')">Newest First</a>
          <a @click="filterCompanies('type')">By Type</a>
        </div>
        <button class="ic ic-pin" title="Filter" @click.stop="filtersOpened = 'filters'"></button>
        <div class="filters main-filters" v-if="filtersOpened === 'filters'" @click.stop>
          <div class="region-filters column">
            <div>Regions</div>
            <div class="region-filter" v-for="region in regions" :key="region">
              <el-checkbox :checked="selectedRegions.includes(region)" @change="updateRegionFilters($event, region)">{{region}}</el-checkbox>
            </div>
          </div>
          <div class="county-filters column">
            <div>Counties</div>
            <div v-for="county in counties" :key="county" class="county-filter">
              <el-checkbox :checked="selectedCounties.includes(county)" @change="updateCountyFilters($event, county)">{{county}}</el-checkbox>
            </div>
          </div>
          <div class="type-filters column">
            <div>Types</div>
            <div v-for="type in types" :key="`filter_${type}`" class="county-filter">
              <el-checkbox :checked="selectedTypes.includes(type)" @change="updateTypeFilters($event, type)">{{type}}</el-checkbox>
            </div>
          </div>
        </div>
      </div> -->
      <div class="companies-list">
        <a
          class="company"
          tabindex="0"
          v-for="company in search(companies, searchTerms, selectedRegions, selectedCounties, selectedTypes)"
          :key="company.key"
          :company="company.key"
          @click="openCompany(company, $event)"
          @mouseover="focusCompany(company)"
          @mouseout="closeWindow(true)"
        >
          <div class="company-type">
            <i :class="['ic', `ic-${getIcon(company.type)}`]"></i>
          </div>
          <div class="company-details">
            <div class="company-name">{{company.name}}</div>
            <div class="company-address">{{company.address}}</div>
            <div class="company-city">{{company.city}}, {{company.county}}</div>
          </div>
          <div class="company-stats">
            <button class="ic ic-print" @click="printCompany($event, company)"></button>
          </div>
        </a>
      </div>
      <div class="add-button">
        <el-button @click="openNewCompany" type="primary" size="small" icon="el-icon-plus">Add your business</el-button>
      </div>
    </aside>
    <div class="company-container" :opened="companyOpened">
      <div class="company-card" v-if="selectedCompany">
        <div class="close-btn">
          <button class="ic ic-close" @click="closeCompany"></button>
        </div>
        <div class="company-cover">
          <img v-if="selectedCompany.cover" :src="selectedCompany.cover" :alt="selectedCompany.name">
        </div>
        <div class="pictures" v-if="selectedCompany.pictures">
          <div v-for="(picture, i) in selectedCompany.pictures.filter(p => p)" :key="i" class="picture-container">
            <a @click.stop="selectedImage = picture">
              <div class="picture" :style="{backgroundImage: `url(${picture})`}"></div>
            </a>
          </div>
        </div>
        <div class="company-title">
          <h1>{{selectedCompany.name}}</h1>
          <div class="company-socials">
            <a v-if="selectedCompany.facebook" :href="selectedCompany.facebook" class="social fb">
              <i class="ic ic-facebook"></i>
            </a>
            <a v-if="selectedCompany.twitter" :href="selectedCompany.twitter" class="social tw">
              <i class="ic ic-twitter"></i>
            </a>
            <a v-if="selectedCompany.gplus" :href="selectedCompany.gplus" class="social gplus">
              <i class="ic ic-gplus"></i>
            </a>
            <a v-if="selectedCompany.linkedin" :href="selectedCompany.linkedin" class="social lk">
              <i class="ic ic-linkedin"></i>
            </a>
            <a v-if="selectedCompany.instagram" :href="selectedCompany.instagram" class="social instagram">
              <i class="ic ic-instagram"></i>
            </a>
          </div>
        </div>
        <div class="company-address" v-if="selectedCompany.address">
          <div>{{selectedCompany.address}}</div>
          <div>{{selectedCompany.city}}, {{selectedCompany.county}}</div>
        </div>
        <div class="company-website" v-if="selectedCompany.website">
          <a :href="(selectedCompany.website.startsWith('http') ? '' : 'http://') + selectedCompany.website" target="_blank"><i class="ic ic-website"></i>&nbsp;{{selectedCompany.website}}</a>
        </div>
        <div class="company-phone" v-if="selectedCompany.phone">
          <a :href="`tel:${selectedCompany.phone}`"><i class="ic ic-phone"></i>&nbsp;{{selectedCompany.phone}}</a>
        </div>
        <div class="company-description" v-html="selectedCompany.description"></div>
      </div>
    </div>
    <main>
      <div class="map-container" onclick="event.stopPropagation()">
        <div class="new-company" :opened="newCompanyOpened">
          <div class="close-btn">
            <button class="ic ic-close" @click="closeCompany"></button>
          </div>
          <div class="infos" v-if="selectedPanel === 'infos'">
            <div class="info-section">
              <h4>Information</h4>
              <p>Tour de France – Ireland Edition is to give you a simple overview of some French businesses established in Ireland and access details available.<br><br>As a French entrepreneur in Ireland, you can also add your own details. This is a free registration.</p>
            </div>
            <div class="info-section">
              <h4>Contact us</h4>
              <p>Queries may be submitted to <a href="mailto:tourdefrance.eire@gmail.com">tourdefrance.eire@gmail.com</a><br>This page has been designed by <a href="https://www.blackpugstudio.com" target="_blank">Black Pug Studio</a></p>
            </div>
            <div class="info-section">
              <h4>Disclaimers</h4>
              <p>Limit of Liability: Tour de France Ireland Edition does not guarantee results or accuracy from the use of listed names (those details are managed by each of the businesses), nor shall they be liable for any loss or damages sustained by the user through the use of any list.<br><br>List details are approximate and subject to change due to constant updates and revisions.</p>
            </div>
          </div>
          <div class="add-business" v-else>
            <h2>Add your business</h2>
            <form @submit="submitCompany">
              <div class="fieldgroup">
                <div class="field">
                  <input type="text" placeholder="Name" name="name" maxlength="80" required>
                </div>
              </div>
              <div class="fieldgroup">
                <div class="field m">
                  <input type="email" placeholder="Email" name="email" maxlength="255" required>
                </div>
                <div class="field m">
                  <input
                    type="text"
                    pattern="[0-9+]+"
                    placeholder="Phone"
                    name="phone"
                    maxlength="20"
                    required>
                </div>
              </div>
              <div class="fieldgroup">
                <div class="field m">
                  <input type="text" placeholder="Address" name="address" maxlength="255" required>
                </div>
                <div class="field m">
                  <input type="text" placeholder="City" name="city" maxlength="255" required>
                </div>
              </div>
              <div class="fieldgroup">
                <div class="field m">
                  <select name="county" required>
                    <option value="">County</option>
                    <option :value="county" :key="county" v-for="county in counties">{{county}}</option>
                  </select>
                </div>
                <div class="field m">
                  <select name="region" required>
                    <option value="">Region</option>
                    <option :value="region" :key="region" v-for="region in regions">{{region}}</option>
                  </select>
                </div>
              </div>
              <div class="fieldgroup">
                <div class="field m">
                  <select name="type" required>
                    <option value="">Type</option>
                    <option :value="type" v-for="type in types" :key="type">{{type}}</option>
                  </select>
                </div>
                <div class="field m">
                  <input type="text" placeholder="Website" name="website" maxlength="300" required>
                </div>
              </div>
              <div class="fieldgroup">
                <div class="field m">
                  <input type="text" placeholder="Facebook" name="facebook" class="social fb" maxlength="300">
                </div>
                <div class="field m">
                  <input type="text" placeholder="Twitter" name="twitter" class="social tw" maxlength="300">
                </div>
              </div>
              <div class="fieldgroup">
                <div class="field m">
                  <input type="text" placeholder="Google+" name="gplus" class="social gplus" maxlength="300">
                </div>
                <div class="field m">
                  <input type="text" placeholder="LinkedIn" name="linkedin" class="social lk" maxlength="300">
                </div>
              </div>
              <div class="fieldgroup">
                <div class="field m">
                  <input type="text" placeholder="Instagram" name="instagram" class="social instagram" maxlength="300">
                </div>
              </div>
              <div class="fieldgroup">
                <div class="field">
                  <textarea name="description" placeholder="Description" maxlength="1000" required></textarea>
                </div>
              </div>
              <div class="buttons">
                <button class="btn" type="submit" :loading="submitting">Submit</button>
              </div>
            </form>
          </div>
        </div>
        <GmapMap
          id="map"
          ref="map"
          :zoom="zoom"
          :center="{ lat: 53.2840511, lng: -9.0837733 }"
          :options="mapOptions"
          @click="closeCompany"
          map-type-id="terrain"
        >
          <GmapInfoWindow
            v-if="!isMobile && hoverCompany"
            :position="windowPosition"
            :opened="true"
            @mouseover="openCompany(false)"
            @click="openCompany(hoverCompany, $event)"
            @closeclick="closeCompany"
          >
            <a @click="openCompany(hoverCompany, $event)">
              <img v-if="hoverCompany.cover" width="200" style="display: block;" :src="hoverCompany.cover" :alt="hoverCompany.name">
              <p v-else>{{hoverCompany.name}}</p>
            </a>
          </GmapInfoWindow>
          <GmapMarker
            v-for="company in search(companies, searchTerms, selectedRegions, selectedCounties, selectedTypes)"
            :key="company.key"
            :position="{ lat: company.latitude || 53.2840511, lng: company.longitude || -9.0837733 }"
            :icon="require(`../assets/images/tdf_pin.png`)"
            :clickable="true"
            @click="openCompany(company)"
            @mouseover="openWindow(company)"
          />
        </GmapMap>
      </div>
    </main>
    <div ref="toast" class="toast"></div>
    <div class="overlay" fixed :opened="Boolean(selectedImage)" @click.stop="selectedImage = null">
      <div class="dialog auto" @click.stop>
        <a class="ic ic-close" @click="selectedImage = null"></a>
        <img v-if="selectedImage" :src="selectedImage" alt="" class="preview">
      </div>
    </div>
  </div>
</template>

<script>
import serialize from 'form-serialize'

export default {
  name: 'MapView',
  props: {
    companies: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      types: [
        "Bar",
        "Cafe",
        "Indutry",
        "Manufacturing",
        "Farming",
        "Craft",
        "Restaurant",
        "Technology",
        "Shop",
        "Hotel",
        "Hairdresser",
        "Wholesale",
        "Health",
        "Social/Health Service",
        "Government Body",
        "Photographer",
        "Media",
        "Artist",
        "Education",
        "Bakery",
        "Association",
        "Leisure",
        "Beauty Salon",
        "Supplier",
        "Retailer",
        "Consultant",
        "Bank/Finance Services",
        "Transportation",
        "Medical Industry",
        "Seafood/Fishing",
        "Other"
      ],
      counties: [
        'Carlow',
        'Cavan',
        'Clare',
        'Cork',
        'Donegal',
        'Dublin',
        'Galway',
        'Kerry',
        'Kildare',
        'Kilkenny',
        'Laois',
        'Leitrim',
        'Limerick',
        'Longford',
        'Louth',
        'Mayo',
        'Meath',
        'Monaghan',
        'Offaly',
        'Roscommon',
        'Sligo',
        'Tipperary',
        'Waterford',
        'Westmeath',
        'Wexford',
        'Wicklow'
      ],
      regions: [
        'Connaught',
        'Leinster',
        'Munster',
        'Ulster'
      ],
      isMobile: window.innerWidth <= 650,
      zoom: 7,
      selectedPanel: 'add',
      selectedCounties: [],
      selectedRegions: [],
      selectedTypes: [],
      hoverCompany: null,
      selectedCompany: null,
      selectedImage: null,
      menuOpened: false,
      companyOpened: false,
      newCompanyOpened: false,
      filtersOpened: false,
      submitting: false,
      searchTerms: "",
      mapOptions: {
        disableDefaultUI: true,
      },
      icons: {
        'Government Body': 'government',
        'Beauty Salon': 'face',
        'Social/Health Service': 'health',
        'Medical Industry': 'health',
        'Bank/Finance Services': 'accountant',
        'Seafood/Fishing': 'fishing'
      }
    }
  },
  mounted: function() {
    document.body.addEventListener('click', () => this.closeCompany())
    window.addEventListener('openNewCompany', e => this.openNewCompany(e.detail.panel))
    window.addEventListener('toggleMenu', () => {
      this.menuOpened = !this.menuOpened
      this.newCompanyOpened = false
    })
  },
  methods: {
    openNewCompany() {
      window.dispatchEvent(new CustomEvent('open-dialog', { detail: { dialog: 'company' } }))
    },
    openWindow(company) {
      clearTimeout(this.companyTO)
      if(!company) return
      this.windowPosition = { lat: company.latitude, lng: company.longitude }
      this.hoverCompany = company
      const el = document.querySelector(`.companies-list .company[company="${company.key}"]`)
      if(el) el.focus()
    },
    closeWindow(skip) {
      clearTimeout(this.companyTO)
      if(typeof skip !== "boolean") this.companyTO = setTimeout(() => this.hoverCompany = null, 1000)
      else this.hoverCompany = null
    },
    openCompany(company, e) {
      if(e) e.Ia ? e.Ia.stopPropagation() : e.stopPropagation()
      this.selectedCompany = company
      if(this.selectedCompany && this.selectedCompany.key) {
        this.db().ref(`/stats/perVenue/${this.selectedCompany.key}`).transaction(stat => {
          return parseInt(stat || 0) + 1
        })
      }
      this.zoom = 12
      this.companyOpened = true
      this.newCompanyOpened = false
    },
    closeCompany() {
      this.selectedCompany = null
      this.companyOpened = this.newCompanyOpened = this.filtersOpened = false
      this.closeWindow(true)
    },
    getIcon(type) {
      if(this.icons[type]) return this.icons[type]
      return type.replace(/ /g, '-').toLowerCase()
    },
    printCompany(e, company) {
      this.openCompany(company, e)
      setTimeout(() => window.print(), 200)
    },
    updateCountyFilters(e, county) {
      const index = this.selectedCounties.indexOf(county)
      if(e && index === -1) this.selectedCounties = this.selectedCounties.concat(county)
      else if(!e && index > -1) this.selectedCounties = this.selectedCounties.filter(c => c !== county)
    },
    updateRegionFilters(e, region) {
      const index = this.selectedRegions.indexOf(region)
      if(e && index === -1) this.selectedRegions = this.selectedRegions.concat(region)
      else if(!e && index > -1) this.selectedRegions = this.selectedRegions.filter(r => r !== region)
    },
    updateTypeFilters(e, type) {
      const index = this.selectedTypes.indexOf(type)
      if(e && index === -1) this.selectedTypes = this.selectedTypes.concat(type)
      else if(!e && index > -1) this.selectedTypes = this.selectedTypes.filter(t => t !== type)
    },
    filterCompanies(filter) {
      switch(filter) {
        case 'type':
          this.companies = this.companies.sort((a, b) => a.type.localeCompare(b.type))
          break
        default:
          this.companies = this.companies.sort((a, b) => b.created_at - a.created_at)
          break
      }
    },
    focusCompany(company) {
      this.$refs.map.panTo({
        lat: company.latitude || 53.2840511,
        lng: company.longitude || -9.0837733
      })
      this.openWindow(company)
    },
    search(companies, search, regions, counties, types) {
      return companies.filter(c => {
        return c.name.toLowerCase().indexOf(search.toLowerCase()) > -1 &&
          c.address &&
          (!regions.length || regions.includes(c.region)) &&
          (!counties.length || counties.includes(c.county)) &&
          (!types.length || types.includes(c.type))
      })
    },
    submitCompany(e) {
      e.preventDefault()
      if(this.submitting) return false
      this.submitting = true
      const form = e.target
      fetch(`https://tour-de-france-671b8.firebaseapp.com/api/companies`, {
        body: JSON.stringify(serialize(form, { hash: true })),
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(res => {
        if(res.ok) {
          form.reset()
          this.displayToast("Your application has been sent to our administrative team. We'll contact you as soon as possible.")
        }
        else this.displayToast("A similar company is already registered with this email address.")
        this.submitting = false
      })
      .catch(() => {
        this.displayToast("An unknown error occurred. Please try again.")
        this.submitting = false
      })
    },
    displayToast(message) {
      this.$refs.toast.innerHTML = `<p>${message}</p>`
      this.$refs.toast.setAttribute('opened', '')
      setTimeout(() => this.$refs.toast.removeAttribute('opened'), 3000)
    }
  }
}
</script>

<style scoped>
.view {
  overflow: hidden;
}

aside {
  position: absolute;
  top: 0;
  left: 0;
  width: 478px;
  height: 100%;
  max-width: 100%;
  background: #EBEFF0;
  box-shadow: 3px 0 17px #BBC1C5;
  z-index: 1;
}

main {
  position: absolute;
  top: 0;
  left: 478px;
  right: 0;
  height: 100%;
}

.search {
  padding: 0 40px;
  position: relative;
  z-index: 1;
}

.search .filters {
  position: absolute;
  right: 40px;
  top: 100%;
  background: #fff;
  z-index: 1;
  padding: 4px 8px;
  box-shadow: 0 3px 4px rgba(0,0,0,.08);
  max-height: 220px;
  overflow: auto;
}

.search .filters.main-filters {
  width: auto;
  left: 40px;
}

.search .filters.main-filters .column {
  width: 33.3333333%;
  float: left;
}

.search .filters a {
  display: block;
  padding: 8px 16px;
}

.search .filters label {
  display: block;
}

.add-button {
  text-align: center;
  padding: 12px;
  background: #fff;
}

@media print {
  .search,
  .companies-list .company .company-stats {
    display: none;
  }
  .companies-list .company .company-details {
    width: calc(100% - 24px);
  }
  .view {
    top: 0;
    bottom: 0;
  }
  aside,
  main {
    position: relative;
    left: 0;
    right: 0;
    width: auto;
    /* page-break-after: always; */
  }
  main {
    height: 56.25vh;
    page-break-before: always;
  }
  aside .companies-list {
    overflow: initial;
    height: auto;
    margin: 0;
  }
  aside .companies-list:after {
    content: '';
    display: block;
    clear: both;
  }
  aside .companies-list .company {
    float: left;
    width: 50%;
    height: 12.5vh;
    padding: 24px;
  }
}

@media screen and (min-width: 1025px) {
  .search .filters a:hover {
    background: rgba(0,0,0,.08)
  }
}

.companies-list {
  position: relative;
  height: calc(100% - 56px);
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.companies-list .company {
  display: block;
  padding: 24px 40px;
  letter-spacing: .1em;
  font-size: 12px;
  color: #737373;
  transition: background .16s;
}

@media screen and (min-width: 1025px) {
  .companies-list .company:hover,
  .companies-list .company:focus {
    background: rgba(0,0,0,.08);
  }
}

.companies-list .company:after {
  content: '';
  display: block;
  clear: both;
}

.companies-list .company .company-type,
.companies-list .company .company-details,
.companies-list .company .company-stats {
  float: left;
}

.companies-list .company .company-details {
  width: calc(100% - 48px);
  padding: 0 16px;
}

.companies-list .company .company-name {
  font-weight: bold;
  font-size: 16px;
  color: #2C3E50;
}

.company-container,
.new-company {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  overflow: auto;
  width: 662px;
  max-width: 100%;
  background: #f2f5f5;
  box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
  z-index: 1;
  padding: 32px 54px;
  transform: translateX(-100%);
  transition: all .16s ease-out;
  visibility: hidden;
  -webkit-overflow-scrolling: touch;
}

.infos h4 {
  display: inline-block;
  border-bottom: 3px solid #2980B7;
  text-transform: uppercase;
  font-size: 16px;
  margin: 0 0 8px;
}

.infos .info-section {
  margin-top: 36px;
}

.infos p {
  font-size: 14px;
}

.infos a {
  color: #2980B7;
  text-decoration: underline;
}

.new-company {
  left: auto;
  right: 0;
  transform: translateX(100%);
}

.new-company h2 {
  text-align: center;
  text-transform: uppercase;
  font-size: 24px;
  font-weight: bold;
  letter-spacing: .1em;
}

.new-company input.social {
  padding-left: 28px;
  background-size: 14px 14px;
  background-position: 8px center;
  background-repeat: no-repeat;
}

.new-company input.social.fb {
  background-image: url(../assets/images/tdf_fb_color.svg);
}

.new-company input.social.tw {
  background-image: url(../assets/images/tdf_tw_color.svg);
}

.new-company input.social.gplus {
  background-image: url(../assets/images/tdf_gplus_color.svg);
}

.new-company input.social.lk {
  background-image: url(../assets/images/tdf_linkd_color.svg);
}

.new-company input.social.instagram {
  background-image: url(../assets/images/tdf_instagram_color.svg);
}

.company-container[opened],
.new-company[opened] {
  visibility: visible;
  transform: none;
}

@media print {
  .company-container[opened] {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: auto;
    background: #fff;
    z-index: 9999;
    transition: none;
  }
  .company-container[opened] button.ic-close {
    display: none;
  }
}

.close-btn {
  position: absolute;
  top: 4px;
  right: 4px;
}

.close-btn .ic {
  width: 48px;
  height: 48px;
}

.company-container .company-cover {
  margin-bottom: 20px;
}

.company-container .company-cover img {
  display: block;
  margin: auto;
  max-width: 100%;
  max-height: 380px;
}

.company-container .pictures {
  margin: 0 -8px 20px;
}

.company-container .pictures:after {
  content: '';
  display: block;
  clear: both;
}

.company-container .pictures .picture-container {
  float: left;
  width: 25%;
  padding: 0 8px;
}

.company-container .pictures .picture {
  padding-top: 56.25%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.company-container .company-title {
  margin-bottom: 20px;
}

.company-container .company-title h1 {
  font-size: 28px;
  margin: 0;
  font-weight: 500;
  line-height: 1;
  display: inline-block;
  letter-spacing: .1em;
}

.company-container .company-website,
.company-container .company-phone,
.company-container .company-address {
  font-weight: 300;
  font-size: 12px;
  letter-spacing: .1em;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.company-container .company-socials {
  float: right;
}

.company-container .company-socials .social {
  display: inline-block;
  vertical-align: middle;
  margin-left: 8px;
  padding: 4px;
}

.company-container .company-socials .social .ic {
  width: 20px;
  height: 20px;
  display: block;
}

.company-container .company-socials .fb {
  background: #2980B7;
}

.company-container .company-socials .tw {
  background: #4099FF;
}

.company-container .company-socials .gplus {
  background: #DB4E3F;
}

.company-container .company-socials .lk {
  background: #0077B5;
}

.company-container .company-description {
  margin-top: 20px;
  word-wrap: break-word;
}

.search:after {
  content: '';
  display: block;
  clear: both;
}

.search .input-container {
  border-bottom: 1px solid #fff;
  float: left;
  width: calc(100% - 64px);
}

.search button.ic {
  float: right;
}

.search .input-container > * {
  float: left;
}

.search .input-container input {
  border: none;
  width: calc(100% - 24px);
  letter-spacing: .1em;
}

.map-container {
  position: relative;
  overflow: hidden;
  height: 100%;
}

#map {
  width: 100%;
  height: 100%;
}

.info-map {
  width: 200px;
}

.dialog img.preview {
  display: block;
}

@media screen and (max-width: 1148px) {
  aside {
    position: absolute;
    top: 0;
    left: 0;
    transform: translateX(-100%);
    visibility: hidden;
    transition: all .16s ease-out;
  }
  aside[opened] {
    transform: none;
    visibility: visible;
  }
  main {
    left: 0;
  }
}

@media screen and (max-width: 580px) {
  .company-container,
  .new-company {
    padding: 48px 20px;
  }
  .new-company .field.m {
    width: 100%;
  }
  .company-container .company-title h1 {
    font-size: 18px;
    line-height: 28px;
  }
  .search {
    padding: 0 20px;
  }
  .companies-list .company {
    padding: 16px 20px;
  }
}
</style>
